/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconTwitter(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M13.54 3.889a2.968 2.968 0 0 0 1.333-1.683 5.937 5.937 0 0 1-1.929.738 2.992 2.992 0 0 0-.996-.706 2.98 2.98 0 0 0-1.218-.254 2.92 2.92 0 0 0-2.143.889 2.929 2.929 0 0 0-.889 2.15c0 .212.027.442.08.691a8.475 8.475 0 0 1-3.484-.932A8.536 8.536 0 0 1 1.532 2.54a2.993 2.993 0 0 0-.413 1.523c0 .519.12 1 .361 1.445.24.445.57.805.988 1.08a2.873 2.873 0 0 1-1.373-.374v.04c0 .725.23 1.365.69 1.92a2.97 2.97 0 0 0 1.739 1.048 2.937 2.937 0 0 1-1.365.056 2.94 2.94 0 0 0 1.063 1.5 2.945 2.945 0 0 0 1.77.603 5.944 5.944 0 0 1-3.77 1.302c-.243 0-.484-.016-.722-.048A8.414 8.414 0 0 0 5.15 14c.905 0 1.763-.12 2.572-.361.81-.24 1.526-.57 2.147-.988a9.044 9.044 0 0 0 1.683-1.46c.5-.556.911-1.155 1.234-1.798a9.532 9.532 0 0 0 .738-1.988 8.417 8.417 0 0 0 .246-2.429 6.177 6.177 0 0 0 1.508-1.563c-.56.249-1.14.407-1.738.476z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M20.31 5.833a4.451 4.451 0 0 0 2-2.524 8.91 8.91 0 0 1-2.894 1.107 4.487 4.487 0 0 0-1.494-1.06 4.471 4.471 0 0 0-1.827-.38c-1.254 0-2.325.444-3.214 1.333-.89.89-1.334 1.964-1.334 3.225 0 .318.04.664.12 1.037a12.713 12.713 0 0 1-5.226-1.398A12.804 12.804 0 0 1 2.298 3.81a4.49 4.49 0 0 0-.62 2.284c0 .778.181 1.5.542 2.168a4.439 4.439 0 0 0 1.482 1.62 4.31 4.31 0 0 1-2.06-.561v.06c0 1.087.346 2.047 1.036 2.88a4.457 4.457 0 0 0 2.608 1.572 4.405 4.405 0 0 1-1.191.166 5.04 5.04 0 0 1-.856-.082 4.41 4.41 0 0 0 1.594 2.25 4.417 4.417 0 0 0 2.655.904c-1.659 1.302-3.544 1.953-5.655 1.953-.365 0-.726-.024-1.083-.072C2.869 20.317 5.194 21 7.725 21c1.358 0 2.644-.18 3.858-.541 1.215-.361 2.288-.855 3.22-1.482a13.564 13.564 0 0 0 2.525-2.19 12.232 12.232 0 0 0 1.851-2.697c.484-.964.853-1.958 1.107-2.982a12.624 12.624 0 0 0 .369-3.644 9.266 9.266 0 0 0 2.262-2.345 8.9 8.9 0 0 1-2.607.714z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTwitter is deprecated and will be archived soon. Use IconTwitter instead.
 */
export function Experimental__IconTwitter(props) {
  return /*#__PURE__*/React.createElement(IconTwitter, props);
}